import { SearchResults, ApiSearchResults, Connect, ApiConnect,LocationGeneralInfo } from "./types";
import { RadioButtonListItem } from "../../../../components/RadioButtonList";
import * as React from 'react';

export const parseAPISearchResults = (apiSearchResults: ApiSearchResults): SearchResults => {
    return {
        errorSearch: apiSearchResults.error,
        locations: apiSearchResults.locations
    }
}

export const parseAPIConnect = (apiConnect: ApiConnect): Connect => {
    return {
        error: apiConnect.error,
        connected: apiConnect.connected            
    }
}

export const parseLocationToRadioButtonListItems = (locations?: LocationGeneralInfo[]): RadioButtonListItem[] | undefined => {
    return locations?.map(location => {
        return{
            id: location.id,
            name: location?.name,
            enable: (location.otherDealerIdConnected === undefined || location.otherDealerIdConnected === null), 
            itemMessage: ((location.otherDealerIdConnected === undefined || location.otherDealerIdConnected === null)?undefined:"(Location already connected to Dealer " + location.otherDealerIdConnected + ")")
        }
    })
}
